module.exports = __webpack_public_path__ + "img/bsg-pro-tabels-2024.903c62e4.png";